import React from 'react';
import { WHATSAPP_URL } from '../data/seminar';
export function StickyCta() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-cream/95 p-3 backdrop-blur sm:hidden" data-id="element-99" data-mp="3bluet60wto1f">
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center rounded-full bg-gold px-6 py-4 font-sans text-xs font-semibold uppercase tracking-[0.2em] text-navy shadow-soft transition-colors hover:bg-gold-light focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-100" data-mp="2xn4me3p1ccje">
        Reserva tu lugar
      </a>
    </div>;
}